<template>
  <div id="app">
    <common-header v-if="!$route.meta.hideFullHeader & $route.name !== 'ErrorUnauthed'" />
    <router-view />
    <common-footer v-if="!$route.meta.hideFullFooter & $route.name !== 'ErrorUnauthed' & storedFooterFlag" />
  </div>
</template>

<script>
import { getAnonymousUserId } from '@/api/mypage';
import MixinMeta from '@/plugins/mixin-meta';
import MixinUserStorage from '@/plugins/mixin-userstorage';
import CommonHeader from '@/components/parts/CommonHeader';
import CommonFooter from '@/components/parts/CommonFooter';

export default {
  name: 'App',
  components: {
    CommonHeader,
    CommonFooter,
  },
  data() {
    return {
      isFooterDisplay: false,
      hoge: false,
    };
  },
  mixins: [MixinMeta, MixinUserStorage],
  mounted() {
    this.metaSetForDefault();
    this.setUser();
    // this.hoge = true;
    this.$nextTick(() => {
      this.isFooterDisplay = true;
    });
  },
  computed: {
    isLoggedIn() {
      return this.$store.state.user;
    },
    storedFooterFlag() {
      /* eslint dot-notaion: 0 */
      return this.$store.getters['getFooterDisplayFlag'];
    },
  },

  methods: {
    async setUser() {
      try {
        if (this.isLoggedIn) {
          return;
        }
        if (this.getUserStorage()) {
          return;
        }
        const id = await getAnonymousUserId();
        this.setUserStorage(id);
      } catch (e) {
        // console.error(e);
      }
    },
  },
};
</script>

<style lang="scss">
#app {
  position: relative;
}
* {
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  vertical-align: baseline;
  box-sizing: border-box;
  font-size: 14px;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

blockquote,
q {
  quotes: none;
}

blockquote:after,
blockquote:before,
q:after,
q:before {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}


html,
body {
  font-family: "ヒラギノ角ゴ Pro W3", "Hiragino Kaku Gothic Pro", "メイリオ",
    Meiryo, sans-serif;
  color: #666;
  -webkit-text-size-adjust: 100%;
  background-color: #FFF;
}

img {
  max-width: 100%;
}

img,
svg {
  vertical-align: bottom;
}


svg {
  height: auto;
}

main {
  display: block;
}

a,
button,
select {
  color: #666;
}

a,
a::before,
a::after,
a *,
button,
button::before,
button::after,
button * {
  text-decoration: none;
}

html {
  font-size: 12px;
}

a:hover,
button:hover {
  opacity: 0.7;
}


header,
footer,
main,
nav,
article,
aside,
section{
  display: block;
}


input,select{
    -webkit-appearance: none;
}

a, a::before, a::after, a *, button, button::before, button::after, button * {
    text-decoration: none;
    cursor: pointer;
    outline: none;
}

a, button {
    color: #666;
}

input[type="text"], input[type="email"], input[type="button"], input[type="tel"], input[type="date"], input[type="search"], input[type="submit"], textarea, button, select {
    margin: 0;
    padding: 0;
    border: none;
    outline: none;
    border-radius: 0;
    background: white;
    appearance: none;
}

select {
  appearance: menulist;
  -webkit-appearance: menulist;
  -moz-appearance: menulist;
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  padding: 3px;
}

input::placeholder {
  color: #ccc;
}

input[type="text"],
input[type="password"],
input[type="tel"],
input[type="email"] {
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  padding: 4px 8px;
}


input[type="email"],
input[type="text"] {
  appearance: text;
  -webkit-appearance: text;
  -moz-appearance: text;
}

input[type="checkbox"] {
  appearance: checkbox;
  -webkit-appearance: checkbox;
  -moz-appearance: checkbox;
}

input[type="tel"] {
  appearance: tel;
  -webkit-appearance: tel;
  -moz-appearance: tel;
}

input[type="tel"] {
  appearance: tel;
  -webkit-appearance: tel;
  -moz-appearance: tel;
}

select {
  appearance: menulist;
  -webkit-appearance: menulist;
  -moz-appearance: menulist;
  border-width: 1px;
  border-style: solid;
  border-color: #ccc;
  padding: 3px;
}

.u-select-wrapper {
  position: relative;
  background: #FFF;
  border: 1px solid #CCC;
  overflow: hidden;
  height: 100%;
  &:before {
    content:'';
    background-image: url(/static/img/icon-sort-2-grey.png);
    background-size: cover;
    position: absolute;
    top: 50%;
    right: 8px;
    margin-top: -9.5px;
    width: 20px;
    height: 19px;
  }
  & select {
    padding: 0 0 0 10px;
    width: 100%;
    height: 100%;
    border: 0;
    cursor: pointer;
    appearance: none;
  }

  &.double-sort-arrow {
    &:before {
      background-image: url(/static/img/icon-sort-4-s.png);
    }
  }
}

.modal-open {
  overflow: hidden;
}

// google map用のstyle(google mapコンポーネントの中だとcssがscopedになっており、style変更できないためこちらに記述)
div.gm-style-iw-d {
  padding-bottom: 0;
  padding-right: 0;
  overflow: auto !important;
}
.gm-style .gm-style-iw-c {
  padding-top: 0;
  padding-left: 0;
}
.gm-ui-hover-effect {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  border: 1px solid #333 !important;
  border-radius: 50%;
  width: 20px !important;
  height: 20px !important;
  top: 6px !important;
  right: 6px !important;

  img {
    margin: 0 !important;
  }
}

@media(min-width: 640px) {
  .modal-open {
    margin-right: 15px;
  }
}
</style>
